import {
  VOUCHER_RATE_FAILED,
  VOUCHER_RATE_SUCCESS,
  LOADING_VOUCHER_RATE,
  RESET_VOUCHER_RATE,
  VOUCHER_TOGGLE
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
};
export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_VOUCHER_RATE: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }

    case VOUCHER_RATE_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }

    case VOUCHER_RATE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload ,
      };
    }

    case VOUCHER_TOGGLE:
            return {
                ...state,
                data: state.voucherz.map((v, i) => (i !== action.index ? v : { ...v, isSelected: !v.isSelected })),
                networkError: ''
            }


    case RESET_VOUCHER_RATE: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
